<template>
    <v-layout>
        <v-flex>
            <template v-if="changeBrowserDisplay">
                <time-field
                    :value="value"
                    :disabled="disabled"
                    :rules="rules"
                    :editable="editable"
                    class="pb-2"
                    @input="v => $emit('input', v)"
                    @focus="e => $emit('focus', e)"
                    @blur="e => $emit('blur', e)"
                />
            </template>
            <template v-else>
                <time-text-field
                    :value="value"
                    :disabled="disabled"
                    :rules="rules"
                    @input="v => $emit('input', v)"
                    @focus="e => $emit('focus', e)"
                    @blur="e => $emit('blur', e)"
                    @update:error="e => $emit('update:error', e)"
                />
            </template>
        </v-flex>
    </v-layout>
</template>

<script lang="ts">
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import TimeField from '../../atoms/TimeField.vue';
import TimeTextField from '../../atoms/TimeTextField.vue';
import { CurrentBrowserType } from '../../../utils/types/BrowserInformationRelated';

@Component({
    name: 'TimePickerChangedByBrowser',
    components: {
        TimeField,
        TimeTextField,
    },
})
export default class TimePickerChangedByBrowser extends Vue {
    @Prop({ default: '' }) value: string;
    @Prop({ default: false }) disabled: boolean;
    @Prop({ default: () => [] }) rules: Array<any>;
    @Prop({ default: true }) editable: boolean;

    get changeBrowserDisplay(): boolean {
        return (
            CurrentBrowserType.isTridentBrowser() ||
            CurrentBrowserType.isIEBrowser() ||
            CurrentBrowserType.isEdgeBrowser()
        );
    }
}
</script>
